<template>
  <div>
    <modal
      name="team-role"
      :adaptive="true"
      :minHeight="500"
      :maxHeight="auto"
    >
      <div class="text-center mt-4">
        <h6 class="text-gray-600 text-xl font-bold">Add New Role - {{ team.name }}</h6>
      </div>
      <div style="margin: 20px">
        <FormulateForm @submit="addNewRole">
          <div class="flex flex-wrap">
            <div class="w-full xl:w-12/12 mb-4 xl:mb-0 px-2">
              <multiselect 
              v-model="selectedRoles"
              ref="multiselect"
              label="name"
              track-by="name" 
              placeholder="Select at least one role" 
              :multiple="true" 
              :options="roles" 
              :close-on-select="true" 
              :clear-on-select="false" 
              :preserve-search="true" 
              :allow-empty="false" 
              :loading="true"
              >
                <template slot="selection" slot-scope="{ isOpen }">
                  <span class="multiselect__single" v-if="selectedRoles.length &amp;&amp; !isOpen">{{ selectedRoles.length }} options selected</span>
                </template>
              </multiselect>
            </div>
            <div class="w-full xl:w-12/12 xl:mb-0 px-2 mt-5 absolute bottom-0 right-0 h-16">
              <FormulateInput
                input-class="px-4 py-2 w-full rounded bg-blue-500 text-white hover:bg-blue-700"
                type="submit"
                name="Add"
              />
            </div>
          </div>
        </FormulateForm>
      </div>
    </modal>
  </div>
</template>
<script>
/* 
  Class: ModalTeamRoleAssign
  Description: This class representing a team role assign modal.
*/

/* Imports */
import RoleService from "@/services/role.service";
import TeamService from "@/services/team.service";
import Multiselect from 'vue-multiselect';
/* /Imports/ */

export default {
  /* 
    Define data with custom roles state values. 
  */
  data() {
    return {
      roles: [],
      selectedRoles: [],
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    Multiselect
  },

  /* 
    Define props from which we got team data. 
  */
  props: {
    team: null
  },

  methods: {
    /* 
      Call RoleService class to obtain all roles data.
    */
    getRoles() {
       RoleService.getAllRoles().then((response) => {
        this.roles = response.data.roles;
      });
    },

    /* 
      Call RoleService class to add assigned role to the certain team.
    */
    addNewRole() {
      var data = { roles: this.selectedRoles.map((role) => role.id)};
        
      TeamService.assignRole(this.team.id, data).then(() => {
        location.reload();
      });
    },
  },

  /* 
    Define computed properties to obtain different getters and setters and save them into the instance. 
  */
  computed: {
    /* 
      Obtain current user object from the store. 
    */
    currentUser() {
      return this.$store.state.auth.user;
    },
  },

  /* 
    Check if user is authenticated and load all roles after the instance.
  */
  mounted() {
    if (!this.currentUser) {
      this.$router.push("/login");
    }

    this.getRoles();
  }
};
</script>
